var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{style:({'counter-reset': `li ${_vm.editions.length + 1}`}),attrs:{"reversed":""}},_vm._l((_vm.editions),function(d,i){return _c('li',{key:i + 1},[_c('a',{attrs:{"href":d.link,"target":"_blank"}},[_vm._v(_vm._s(d.name))]),_c('span',{staticClass:"mon-period"},[_vm._v(_vm._s(d.date))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }